// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RXLG","comment":"styles_comment__dkfH5"};